import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'auQuickSearchName' })
export class AuQuickSearchNamePipe implements PipeTransform {
	transform(values: any, searchText: string, keys: string[] = ['name']): any {
		if (!values) {
			return [];
		}
		if (typeof searchText !== 'string') {
			return values;
		}

		if (searchText === undefined) {
			return values;
		}

		return values.filter(value => {
			return keys.some(key => {
				return value[key]?.toLocaleLowerCase().includes(searchText.toLocaleLowerCase());
			});
		});
	}
}
